export default "__VITE_ASSET__DfOA30ZT__"